import { render, staticRenderFns } from "./MainJouErrorsCard.vue?vue&type=template&id=762eff5f&scoped=true&"
import script from "./MainJouErrorsCard.vue?vue&type=script&lang=js&"
export * from "./MainJouErrorsCard.vue?vue&type=script&lang=js&"
import style0 from "./MainJouErrorsCard.vue?vue&type=style&index=0&id=762eff5f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762eff5f",
  null
  
)

export default component.exports